import {
  collection,
  doc,
  getDoc,
  getDocs,
  writeBatch,
  setDoc,
} from 'firebase/firestore';
import { db } from '../../firebase';
import {
  mergeCategoryRename,
  setEventCategoryRenames,
  categoryRenamePatch,
  validateCategoryRename,
  getEventCategoryRenames,
} from './eventCategories';

export const EVENT_CATEGORY_CONFIG_PATH = ['appConfig', 'eventCategories'];
const EVENTS_COLLECTION = 'v2-events';
const BATCH_LIMIT = 500;

export async function loadEventCategoryRenames() {
  const snap = await getDoc(doc(db, ...EVENT_CATEGORY_CONFIG_PATH));
  const renames = snap.exists() && snap.data()?.renames && typeof snap.data().renames === 'object'
    ? snap.data().renames
    : {};
  setEventCategoryRenames(renames);
  return getEventCategoryRenames();
}

/**
 * Rename one content category on every event, then store the alias.
 * Throws on validation or if a batch fails before that batch commits.
 * @returns {Promise<{ updated: number }>}
 */
export async function renameEventCategory(from, to, existingLabels = []) {
  const check = validateCategoryRename(from, to, existingLabels);
  if (!check.ok) {
    const error = new Error(check.message);
    error.code = 'validation';
    throw error;
  }

  const snapshot = await getDocs(collection(db, EVENTS_COLLECTION));
  const updates = [];
  snapshot.docs.forEach((eventDoc) => {
    const patch = categoryRenamePatch(eventDoc.data(), check.from, check.to);
    if (patch) updates.push({ id: eventDoc.id, patch });
  });

  for (let index = 0; index < updates.length; index += BATCH_LIMIT) {
    const batch = writeBatch(db);
    updates.slice(index, index + BATCH_LIMIT).forEach(({ id, patch }) => {
      batch.update(doc(db, EVENTS_COLLECTION, id), patch);
    });
    await batch.commit();
  }

  const current = getEventCategoryRenames();
  const renames = mergeCategoryRename(current, check.from, check.to);
  await setDoc(doc(db, ...EVENT_CATEGORY_CONFIG_PATH), { renames }, { merge: true });
  setEventCategoryRenames(renames);
  return { updated: updates.length };
}
